module.exports = __webpack_public_path__ + "/Assets/Images/LogoColorWithCircle.svg";